import $http from "../axios";

const state = {
  account: {}
};

const getters = {
  account: state => {
    return state.account;
  }
};

const actions = {
  getAccountData({ commit }, account) {
    if (!account.email) {
      return new Promise((resolve, reject) => {
        $http
          .get("account-data")
          .then(res => {
            if (res.data.result === "ok") {
              commit("SET_ACCOUNT_DATA", res.data.payload.student);
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    } else {
      return { data: { result: "ok" } };
    }
  },

  updateAccount({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-account-data", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ACCOUNT_DATA", res.data.payload.student);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updatePassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteAccount(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-account", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteUserImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-user-image", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("DELETE_USER_IMAGE");
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  userNotOrganizationLeaderAnymore({ commit }) {
    commit("SET_USER_IS_ORGANIZATION_LEADER", false);
    commit("SET_USER_CAN_CREATE_ORGANIZATION", true);
    commit("CLEAR_ORGANIZATION_DATA");
  }
};

const mutations = {
  SET_ACCOUNT_DATA(state, accountData) {
    state.account = accountData;
  },

  SET_USER_CAN_CREATE_ORGANIZATION(state, value) {
    state.account.canCreateOrganization = value;
  },

  SET_USER_IS_ORGANIZATION_LEADER(state, value) {
    state.account.isOrganizationLeader = value;
  },

  DELETE_USER_IMAGE(state) {
    state.account.picture = null;
    state.account.googlePictureURL = null;
  },

  CLEAR_ACCOUNT_DATA(state) {
    state.account = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
